export default __webpack_public_path__ + "static/media/a017-7.b1de41fc.svg";